import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ n, label, dark = false }) => (
  <Reveal>
    <div
      data-testid={`chapter-badge-${n}`}
      className={`inline-flex items-center gap-3 rounded-full border px-4 py-1.5 font-mono text-[11px] font-medium uppercase tracking-[0.22em] ${
        dark
          ? "border-white/15 text-[#a277fa]"
          : "border-[#201e32]/15 text-[#7650c7]"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-[#a277fa]" : "bg-[#7650c7]"}`} />
      {n} / {label}
    </div>
  </Reveal>
);

export { EASE };
